<template>
    <div style="display: flex; flex: 1; flex-direction: column;">
        <div style="display: flex; flex: 1">
            <iframe allowfullscreen="" id="wallsio-iframe" src="https://walls.io/q63cy?nobackground=1&amp;theme=fluid&amp;show_header=0&amp;columns=1" style="border:0;height:100%;width:100%"></iframe>
        </div>
    </div>
</template>

<script>
    export default {
        name: "social"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/social/social.vue